import { Button, DialogTitle } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CommonUrl, NONCE, processMsg, TIME_STAMP } from '../../../common-url/CommonUrl';



export default function DeviceForm({ data }) {

    const [formData, setFormData] = useState({})
    const [loading, setLoading] = useState(false);

    const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
    const history = useHistory();

    useEffect(() => {
        setFormData(data)
    }, [])

    const handleCloseSuccess = () => {
        history.push("/devices")
    }

    // ----------------------------------------------------------------------------
    // ------------------------------Add Device------------------------------------
    // ----------------------------------------------------------------------------

    const onFormUpdate = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        fetch(CommonUrl.devicesBaseUrl + "/update-device", {
            method: "post",
            body: JSON.stringify({
                _id: formData._id,
                vDeviceSerialNo: formData.vDeviceSerialNo,
                vDeviceName: formData.vDeviceName,
                tiDeviceType: formData.tiDeviceType,
                tiDeviceStatus: formData.tiDeviceStatus,
                vFirmwareVersion: formData.vFirmwareVersion,
                vProductGroup: formData.vProductGroup,
                vDateOfActivation: formData.vDateOfActivation,
                vManufactureDate: formData.vManufactureDate
            }),
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            }
        }).then(response => response.json()).then(response => {

            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 },)
                handleCloseSuccess();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 },)
                setTimeout(() => {
                    setLoading(false)
                }, 2000);
            }
        })
    }

    // ----------------------------------------------------------------------------
    // ------------------------------Add Device------------------------------------
    // ----------------------------------------------------------------------------

    const onFormAdd = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        fetch(CommonUrl.devicesBaseUrl + "/add-device", {
            method: "post",
            body: JSON.stringify({
                _id: formData._id,
                vDeviceSerialNo: formData.vDeviceSerialNo,
                vDeviceName: formData.vDeviceName,
                tiDeviceType: formData.tiDeviceType,
                tiDeviceStatus: formData.tiDeviceStatus,
                vFirmwareVersion: formData.vFirmwareVersion,
                vProductGroup: formData.vProductGroup,
                vDateOfActivation: formData.vDateOfActivation,
                vManufactureDate: formData.vManufactureDate
            }),
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            }
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 },)
                handleCloseSuccess();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 },)
                setTimeout(() => {
                    setLoading(false)
                }, 2000);
            }
        })
    }

    return (
        <>
            <div className="container pr-10 pl-10">
                <DialogTitle className="text-center " id="alert-dialog-title"><span className="text-primary">{data._id ? ("Update ") : ("Add ")}</span>Device Details</DialogTitle>
                <hr className="solid mt-0 mb-5"></hr>
                <div className=" px-5">
                    <form onSubmit={data._id ? onFormUpdate : onFormAdd} autoComplete="off">
                        <div className="row mx-auto">
                            <div className="col-sm-6">
                                <div className=" form-group ">
                                    <label className="col-sm-12 col-form-label font-weight-bold ">Serial No</label>
                                    <input id="standard-basic"
                                        className="form-control"
                                        type="text"
                                        placeholder="a1:2b:cd:33:ef:45"
                                        defaultValue={data._id ? (data.vDeviceSerialNo) : ("")}
                                        onInvalid={(e) => e.target.setCustomValidity('Enter the Serial No')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setFormData({ ...formData, vDeviceSerialNo: e.target.value })}
                                        required  >
                                    </input>
                                </div>
                                <div className=" form-group ">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Device Type</label>
                                    <select
                                        className={formData.vProductGroup != 2 ? ("form-control form-select") : ("d-none")}
                                        defaultValue={data._id ? (data.tiDeviceType) : ("")}
                                        onChange={(e) => setFormData({ ...formData, tiDeviceType: e.target.value })}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Device Type')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        required={formData.vProductGroup != 2}>
                                        <option value="" disabled> Select</option>
                                        <option value={1}>8-Switch Panel</option>
                                        <option value={2}>4-Switch Panel</option>
                                        <option value={3}>3-Pin Switch Panel</option>
                                    </select>
                                    <select
                                        className={formData.vProductGroup == 2 ? ("form-control form-select") : ("d-none")}
                                        defaultValue={data._id ? (data.tiDeviceType) : ("")}
                                        onChange={(e) => setFormData({ ...formData, tiDeviceType: e.target.value })}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Device Type')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        required={formData.vProductGroup == 2}>
                                        <option value="" disabled> Select</option>
                                        <option value={2}>4-Switch Panel{''}</option>
                                    </select>
                                </div>
                                <div className=" form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Manufacture Date</label>
                                    <input
                                        className="form-control"
                                        label="Manufacture Date"
                                        type="date"
                                        onInvalid={(e) => e.target.setCustomValidity('Select Date')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        defaultValue={data._id ? (data.vManufactureDate) : ("")}
                                        onChange={(e) => setFormData({ ...formData, vManufactureDate: e.target.value })}
                                        onKeyDown={(e) => { e.preventDefault() }}
                                        required
                                    />
                                </div>
                                <div className=" form-group  ">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Activation Date</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        onInvalid={(e) => e.target.setCustomValidity('Select Date')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        defaultValue={data._id ? (data.vDateOfActivation) : ("")}
                                        onChange={(e) => setFormData({ ...formData, vDateOfActivation: e.target.value })}
                                        onKeyDown={(e) => { e.preventDefault() }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group ">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Firmware Version</label>
                                    <input id="standard-basic" type="text"
                                        className="form-control"
                                        placeholder="0.0.0"
                                        onInvalid={(e) => e.target.setCustomValidity('Enter Firmware Version')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        defaultValue={data._id ? (data.vFirmwareVersion) : ("")}
                                        onChange={(e) => setFormData({ ...formData, vFirmwareVersion: e.target.value })} >
                                    </input>
                                </div>
                                <div className="  form-group  ">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Product Group</label>
                                    <select
                                        className="form-control form-select"
                                        defaultValue={data._id ? (data.vProductGroup) : ("")}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Product Group')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setFormData({ ...formData, vProductGroup: e.target.value })}
                                        required>
                                        <option value="" disabled> Select </option>
                                        <option value="SmarTouch">SmarTouch</option>
                                        <option value={2} className="d-none" >SmarTap</option>
                                        <option value={3} className="d-none" >SmarTack</option>
                                    </select>
                                </div>
                                <div className=" form-group ">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Device Status</label>
                                    <select
                                        className="form-control form-select"
                                        onInvalid={(e) => e.target.setCustomValidity('Select Device Status')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        defaultValue={data._id ? (data.tiDeviceStatus) : ("")}
                                        onChange={(e) => setFormData({ ...formData, tiDeviceStatus: e.target.value })}
                                        required>
                                        <option value="" disabled>Select</option>
                                        <option value={0}> InActive</option>
                                        <option value={1}> Active </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row form-group justify-content-sm-center">
                            <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                <span>Submit</span>
                                {loading && <span className="ml-3 spinner spinner-dark"></span>}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
